import { Form, Grid, Segment  } from 'semantic-ui-react';
import Loading from './Loading';
import gridsec_logo_white from '../images/gridsec_logo.png'
import PrivacyModal from './PrivacyModal';
import OktaLogin from './OktaLogin';
import Org from './Org/Org';
import MSLogin from './MicrosoftAuth/MicrosoftLogin';

const Login = ({ loading, oktaAuthenticated, msAuthenticated, impersonated }) => {

    if(loading){ return <Loading />}

    if((!loading && oktaAuthenticated) || (!loading && msAuthenticated) || (!loading && impersonated)){ return <Org />}

    if(!loading && !oktaAuthenticated && !msAuthenticated){

        const url = window.location.origin
        const urls = ["https://portal.gridsec.com"]


        return (
            <Grid centered columns={2} className='login-page' style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
                <Segment raised padded="very">
                    <Form>
                        <Segment basic className='dashboard-logo-container'>
                            <img alt='gridsec_logo_white' src={gridsec_logo_white} className='dashboard-logo' style={{maxWidth: "80vh"}} />
                        </Segment>
                            <br/>
                        <Form.Group widths='equal' className='login-button-group'>
                            {urls.includes(url)?
                                <Form.Field>
                                    <OktaLogin />
                                </Form.Field>
                            :
                                <Form.Field>
                                    <MSLogin />
                                </Form.Field>
                            }
                            <Form.Field>
                                <PrivacyModal />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Segment>
            </Grid>
        )
    }
}

export default Login